<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { AdvancedCardV2, Button, Input } from '@Shelly/shelly-design-system';
	//Helpers
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { getErrorOrInfoMessageForMinAndMaxUnit } from 'src/helpers/utilities';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus, VirtualComponentTypes } from 'src/types/VirtualComponents';
	import type { SettingRequest } from 'src/types/requests/settings/setting';

	export let device: Device, status: VCInterfaceStatus, type: VirtualComponentTypes;

	const icon = status.icon || (type === 'number' ? 'fas fa-calculator' : 'fas fa-pen');
	let targetLock = false;
	let waitForResponse = false;
	let unit = status?.unit || '';
	let value: string | number = type === 'number' ? 0 : '';

	$: if (status) {
		const _value = status?.rawValue ?? status.config?.default_value ?? '';
		if (!waitForResponse && !targetLock) {
			value = _value;
		}
		if (targetLock && value == _value) {
			targetLock = false;
		}
	}

	const saveValue = async () => {
		waitForResponse = true;
		const _value = value;
		const res: SettingRequest = await gen2Request(device, `${type}.set`, {
			id: status.id,
			value: type === 'number' ? Number(value) : value,
		});
		if (!res?.isok) {
			targetLock = true;
			value = _value;
		}
		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	$: minMaxInfo =
		type === 'number'
			? getErrorOrInfoMessageForMinAndMaxUnit(
					value === '' || value == null ? NaN : Number(value),
					Number(status.config?.min ?? 0),
					Number(status.config?.max ?? 100),
					unit,
				)
			: {
					error:
						value === '' || value == null
							? $format('field_cannot_be_empty', {
									default: 'This field cannot be empty',
								})
							: value?.toString()?.length >= status?.config?.max_len
								? $format('max_text_length_error_description', {
										values: { max_len: status?.config?.max_len },
										default: 'Value must be less then or equal to {max_len}.',
									})
								: '',
					info: '',
				};
</script>

<AdvancedCardV2 title={translateTemplateTitle(status.name)} class="mb-s">
	<div slot="main" class="d-flex flex-direction-column width-full">
		<Input
			aria-label={type === 'number'
				? $format('input_set_value', { default: 'Set value' })
				: $format('input_text_value', { default: 'Input text value' })}
			class="mb-s"
			size="m"
			{icon}
			value={value?.toString() || ''}
			info={minMaxInfo.info}
			error={minMaxInfo.error}
			on:focus={(e) => {
				targetLock = true;
			}}
			on:input={(e) => {
				targetLock = true;
				value = e.target['value'];
			}}
			id="input-0xsbk3s"
		/>
		<Button
			size="m"
			width="full"
			class="mb-s"
			loading={waitForResponse}
			disabled={waitForResponse || minMaxInfo.error}
			on:click={saveValue}
			>{$format('button_save')}
		</Button>
	</div>
</AdvancedCardV2>
